Object.defineProperty(exports, "__esModule", {
    value: true
});
var _class_call_check = require("@swc/helpers/_/_class_call_check");
var _create_class = require("@swc/helpers/_/_create_class");
var require_logger = require('../logger.cjs');
var require_tool = require('../tool.cjs');
require('../index.cjs');
//#region src/utils/hooks/pluginSystem.ts
var PluginSystem = /*#__PURE__*/ function() {
    "use strict";
    function PluginSystem(lifecycle) {
        _class_call_check._(this, PluginSystem);
        this.registerPlugins = {};
        this.lifecycle = lifecycle;
        this.lifecycleKeys = Object.keys(lifecycle);
    }
    _create_class._(PluginSystem, [
        {
            key: "applyPlugin",
            value: function applyPlugin(plugin, instance) {
                require_logger.assert(require_tool.isPlainObject(plugin), "Plugin configuration is invalid.");
                var pluginName = plugin.name;
                require_logger.assert(pluginName, "A name must be provided by the plugin.");
                if (!this.registerPlugins[pluginName]) {
                    var _plugin_apply;
                    this.registerPlugins[pluginName] = plugin;
                    (_plugin_apply = plugin.apply) === null || _plugin_apply === void 0 ? void 0 : _plugin_apply.call(plugin, instance);
                    Object.keys(this.lifecycle).forEach((key)=>{
                        var pluginLife = plugin[key];
                        if (pluginLife) this.lifecycle[key].on(pluginLife);
                    });
                }
            }
        },
        {
            key: "removePlugin",
            value: function removePlugin(pluginName) {
                require_logger.assert(pluginName, "A name is required.");
                var plugin = this.registerPlugins[pluginName];
                require_logger.assert(plugin, `The plugin "${pluginName}" is not registered.`);
                Object.keys(plugin).forEach((key)=>{
                    if (key !== "name") this.lifecycle[key].remove(plugin[key]);
                });
            }
        }
    ]);
    return PluginSystem;
}();
//#endregion
exports.PluginSystem = PluginSystem; //# sourceMappingURL=pluginSystem.cjs.map
